import { z } from 'zod'

/**
 * Server-internal values arrive as `Date` (from Drizzle). Over the wire (JSON)
 * they're always ISO strings. The union preserves both on the type level so
 * server code that constructs responses with `Date` still compiles, while
 * clients typing the same data after `JSON.parse` get `string`.
 */
export const timestampSchema = z.union([z.date(), z.string()])
export type Timestamp = z.infer<typeof timestampSchema>

/**
 * 32 hex characters with the canonical dash layout, no RFC 4122
 * version/variant gating. Zod's `.uuid()` is strict and rejects the seeded
 * fixture UUIDs (which use repeating-char patterns for grep-ability —
 * `cccccccc-...` for SEED_ADMIN_ID, `aaaaaaaa-...` for the seeded
 * role ids). Both callers and the DB accept these freely, so the schema
 * should too.
 */
export const lenientUuidSchema = z
  .string()
  .regex(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
    'Invalid UUID',
  )
